import React from "react";
import { BackButtonLogo, SideBarSearchLogo } from "../../assets/icons/index.js";
import { TextInput, SnackMsg } from "../../components/index.js";
import { colors } from "../../config/colors.js";
import Button from "react-bootstrap/Button";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import { Typography } from "@mui/material";
import "../../App.css";
import PropTypes from "prop-types";
import { MIGRATE_PAGE_CONSTANTS } from "../../config/constants.js";
import { MAX_WIDTH, TEXT_ALIGN_LEFT } from "../../config/styles.js";

const MigratePage = ({
  onSearch,
  onMigrate,
  searchText,
  setSearchText,
  backButonHadler,
  isSearched,
  issearchFound,
  merchantId,
  schoolName,
  category,
  currency,
  imageURL,
  twitter,
  website,
  iconURL,
}) => {
  const merchantDetailsList = [
    {
      rowIndex: 1,
      rowData: [
        { title: "Merchant ID", value: merchantId },
        { title: "School name", value: schoolName },
        { title: "Category", value: category },
      ],
    },
    {
      rowIndex: 2,
      rowData: [
        { title: "Currency", value: currency },
        { title: "Icon URL", value: iconURL },
        { title: "Image URL", value: imageURL },
      ],
    },
    {
      rowIndex: 3,
      rowData: [
        { title: "Twitter", value: twitter },
        { title: "Website", value: website },
        { title: "", value: "" },
      ],
    },
  ];
  return (
    <div className="welcome-page-container">
      <div className="migrate-page-header">
        <div
          role="button"
          onClick={backButonHadler}
          onKeyDown={(event) => {
            if (event.key === "Enter") backButonHadler();
          }}
          tabIndex="0"
        >
          <BackButtonLogo />
        </div>

        <div className="d-flex flex-column gap-1">
          <Typography variant="body2">
            {MIGRATE_PAGE_CONSTANTS.HEADER}
          </Typography>
          <div>
            <Breadcrumb>
              <Breadcrumb.Item
                href="#"
                bsPrefix="breadcrumb-item"
                onClick={backButonHadler}
              >
                <Typography variant="h4" component="span">
                  {MIGRATE_PAGE_CONSTANTS.BREADCRUMB_HOME}
                </Typography>
              </Breadcrumb.Item>
              <Breadcrumb.Item href="#" bsPrefix="breadcrumb-item">
                <Typography
                  variant="h4"
                  component="span"
                  sx={{ color: colors.custom }}
                >
                  {MIGRATE_PAGE_CONSTANTS.BREADCRUMB_MIGRATE}
                </Typography>
              </Breadcrumb.Item>
            </Breadcrumb>
          </div>
        </div>
      </div>

      <div className="migrate-page-header">
        <div className="migrate-page-body">
          <Typography variant="body1" sx={{ textAlign: TEXT_ALIGN_LEFT }}>
            {MIGRATE_PAGE_CONSTANTS.BODY1}
            <br />
            {MIGRATE_PAGE_CONSTANTS.BODY2}
          </Typography>

          <div className="d-flex flex-row w-100">
            <TextInput
              id="MerchantId"
              label="Merchant ID"
              value={searchText}
              className="migrate-page-input-style"
              onChange={(event) => {
                setSearchText(event.target.value);
              }}
              error={isSearched && !issearchFound}
            />
            <Button className="migrate-search-button" onClick={onSearch}>
              <SideBarSearchLogo bgColor="#0E0E0E" />
            </Button>
          </div>

          {isSearched ? (
            <div className="w-100">
              {issearchFound ? (
                <div
                  style={{
                    display: "block",
                    paddingBottom: 24,
                    width: MAX_WIDTH,
                  }}
                >
                  <div className="migrate-searched-title">
                    {MIGRATE_PAGE_CONSTANTS.MERCHANT_DETAILS}
                  </div>
                  {merchantDetailsList.map((item, index) => (
                    <div className="d-flex flex-row mt-3" key={"row" + index}>
                      {item.rowData.map((data, index) => (
                        <div
                          className="migrate-details-item"
                          key={data.rowIndex + "item" + index}
                        >
                          <div className="migrate-details-header">
                            {data.title}
                          </div>
                          <div className="migrate-details-body">
                            {data.value || "-"}
                          </div>
                        </div>
                      ))}
                    </div>
                  ))}
                </div>
              ) : (
                <div className="d-flex flex-row w-100 align-items-center">
                  <div className="errorIcon" style={{ margin: 4 }} />
                  <Typography variant="h4" sx={{ color: colors.error }}>
                    {MIGRATE_PAGE_CONSTANTS.RECORD_NOT_FOUND}
                  </Typography>
                </div>
              )}
            </div>
          ) : null}

          <Button
            className="migrate-button-style"
            onClick={onMigrate}
            disabled={!issearchFound}
          >
            {MIGRATE_PAGE_CONSTANTS.MIGRATE_BUTTON}
          </Button>
        </div>
      </div>
    </div>
  );
};

MigratePage.propTypes = {
  onSearch: PropTypes.func,
  onMigrate: PropTypes.func,
  searchText: PropTypes.string,
  setSearchText: PropTypes.func,
  backButonHadler: PropTypes.func,
  isSearched: PropTypes.bool,
  issearchFound: PropTypes.bool,
  merchantId: PropTypes.string,
  schoolName: PropTypes.string,
  category: PropTypes.string,
  currency: PropTypes.string,
  imageURL: PropTypes.string,
  twitter: PropTypes.string,
  website: PropTypes.string,
  iconURL: PropTypes.string,
};

export default MigratePage;
